import { createSlice } from '@reduxjs/toolkit';
import {
	fetchProfileAction,
	updateProfileAction,
} from '../actions/profileAction';

const initialState: any = {
	data: null,
	isLoading: true,
	updateLoader: false,
	error: null,
};

const ProfileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		clearProfileRedux: () => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		// Fetch Profile
		builder.addCase(fetchProfileAction.pending, (state) => {
			state.isLoading = true;

			state.error = null;
		});
		builder.addCase(fetchProfileAction.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action?.payload?.data;
		});
		builder.addCase(fetchProfileAction.rejected, (state, action: any) => {
			state.isLoading = false;
			state.error = action.payload;
		});

		// Update Profile
		builder.addCase(updateProfileAction.pending, (state) => {
			state.updateLoader = true;
			state.error = null;
		});
		builder.addCase(updateProfileAction.fulfilled, (state, action) => {
			state.updateLoader = false;
			state.data = action?.payload?.data;
		});
		builder.addCase(updateProfileAction.rejected, (state, action: any) => {
			state.updateLoader = false;
			state.error = action.payload;
		});
	},
});

export default ProfileSlice;
export const { clearProfileRedux } = ProfileSlice.actions;
